var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "800" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "info white--text" },
            [
              _c("v-icon", { staticClass: "mr-2", attrs: { dark: "" } }, [
                _vm._v("mdi-history"),
              ]),
              _vm._v(" Histórico de Assinaturas "),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", small: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialog = false
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { attrs: { color: "red lighten-2", small: "" } },
                    [_vm._v("mdi-close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "pt-4" },
            [
              _vm.loadingHistory
                ? _c("v-progress-linear", {
                    attrs: { indeterminate: "", color: "primary" },
                  })
                : _vm.signatureHistory.length === 0
                ? _c(
                    "v-alert",
                    { attrs: { type: "info", dense: "", outlined: "" } },
                    [
                      _vm._v(
                        " Nenhum histórico de assinatura encontrado para esta folha de ponto. "
                      ),
                    ]
                  )
                : _c(
                    "emc-util-scroll",
                    { attrs: { maxHeight: "60vh" } },
                    [
                      _c(
                        "v-timeline",
                        { attrs: { dense: "" } },
                        _vm._l(
                          _vm.signatureHistory,
                          function (historyItem, index) {
                            return _c(
                              "v-timeline-item",
                              {
                                key: index,
                                attrs: {
                                  color: _vm.getHistoryColor(
                                    historyItem.action
                                  ),
                                  icon: _vm.getHistoryIcon(historyItem.action),
                                  small: "",
                                },
                              },
                              [
                                _c(
                                  "v-card",
                                  { staticClass: "elevation-2" },
                                  [
                                    _c(
                                      "v-card-title",
                                      { staticClass: "text-subtitle-2 py-2" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(historyItem.action_label) +
                                            " "
                                        ),
                                        _c("v-spacer"),
                                        _c(
                                          "span",
                                          { staticClass: "text-caption" },
                                          [
                                            _vm._v(
                                              _vm._s(historyItem.created_at)
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-card-text", { staticClass: "py-2" }, [
                                      _c("div", [
                                        _c("strong", [_vm._v("Responsável:")]),
                                        _vm._v(
                                          " " + _vm._s(historyItem.user_name)
                                        ),
                                      ]),
                                      _c("div", [
                                        _c("strong", [_vm._v("Status:")]),
                                        _vm._v(
                                          " " + _vm._s(historyItem.sign_status)
                                        ),
                                      ]),
                                      historyItem.reason
                                        ? _c("div", [
                                            _c("strong", [
                                              _vm._v("Justificativa:"),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(historyItem.reason) +
                                                " "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialog = false
                    },
                  },
                },
                [_vm._v("Fechar")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }